/**
 * Composant Select
 * Menu déroulant stylisé
 */

import { forwardRef, type SelectHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
    error?: boolean;
}

const Select = forwardRef<HTMLSelectElement, SelectProps>(
    ({ className, error, children, ...props }, ref) => {
        return (
            <select
                className={cn(
                    'flex h-11 sm:h-10 w-full rounded-lg border bg-white dark:bg-[#0F172A] px-3 py-2 text-base sm:text-sm dark:text-[#F1F5F9]',
                    'focus:outline-none focus:ring-2 focus:ring-offset-0',
                    'disabled:cursor-not-allowed disabled:opacity-50',
                    'appearance-none cursor-pointer',
                    // Flèche custom (data-URI via .select-chevron dans index.css)
                    'select-chevron pr-10',
                    error
                        ? 'border-[#EF4444] focus:ring-[#EF4444]/20'
                        : 'border-[#E2E8F0] dark:border-[#334155] focus:ring-[#0F2744]/20 focus:border-[#0F2744] dark:focus:border-[#3B82F6]',
                    className
                )}
                ref={ref}
                {...props}
            >
                {children}
            </select>
        );
    }
);

Select.displayName = 'Select';

export { Select };
